<template>
  <div class="inspection-department">
    <div class="department">
      <div v-html="html"></div>
    </div>
    <div class="unit" @click="onShowPopup">
      <img class="avatarImage" :src="signUrl" />
      送检单位：<span v-if="!signUrl">请点击签名</span>
    </div>
    <div class="dataTime">日期：{{ currentDate }}</div>
    <CanvasSignature
      v-if="showPopup"
      :show="showPopup"
      @close="onHidePopup"
      @confirm="onChanCanvas"
    />
    <div class="next_step" v-if="!content">
      <van-button @click="onSubmit"> 我填完了，提交 </van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Image as VanImage, Toast } from "vant";
import teamApi from "@/apis/inspection-department";
import CanvasSignature from "@/components/canvas-signature";
import upload from "@/utils/upload";
import { backOff } from "@/utils/userInfo";

Vue.use(VanImage);
Vue.use(Toast);
export default {
  data() {
    return {
      showPopup: false,
      signUrl: "",
      token: "",
      supplierId: 1,
      currentDate: "",
      content: "",
      html: ''
    };
  },
  components: {
    CanvasSignature,
  },
  created() {
    if (this.$store.state.appInfo.isApp) {
      this.$bridge.callHandler("getUserInfo", {}, (res) => {
        const d = JSON.parse(res);
        this.token = d.data.accessToken;
        this.init(d.data.accessToken)
      });
    } else {
      const { query } = this.$route;
      this.token = query.token;
      this.init(query.token)
    }
  },
  mounted() {
    const { query } = this.$route;
    console.log("query", query);
    this.supplierId = query.supplierId;
    this.currentDate = new Date().toLocaleDateString("zh-CN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  },
  methods: {
    init(token){
        const params = {
        supplierId: this.supplierId,
      };
      teamApi.getAgreeBook(params, { token }).then((res) => {
        if (res.code == 0) {
          this.signUrl = res.data?.[0].content;
          this.content = res.data?.[0].content;
          this.currentDate = res.data?.[0].createTime
        }
      });
      teamApi.getSupplierImgAgreeBook({
        supplierIds:[this.supplierId]
      }, { token })
        .then(res => {
          if (res.code === 0) {
            this.html = res.data.records[0].imgPath
          }
        })
    },
    onShowPopup() {
      if(this.content){
        return
      }
      this.showPopup = true;
    },
    onHidePopup() {
      this.showPopup = false;
    },
    async base64toFile(urlData) {
      //去掉url的头，并转换为byte
      const bytes = window.atob(urlData.split(",")[1]);
      //处理异常,将ascii码小于0的转换为大于0
      const ab = new ArrayBuffer(bytes.length);
      const ia = new Uint8Array(ab);
      ia.forEach((i, index) => {
        ia[index] = bytes.charCodeAt(index);
      });
      //文件流转换成url路径
      const resetName = `${Math.random()}${+new Date()}`.split(".")[1] + ".png";
      const link = await upload(
        new Blob([ia], {
          type: urlData.split(",")[0].split(":")[1].split(";")[0],
          name: +new Date(),
        }),
        resetName
      );
      return link;
    },
    async onChanCanvas(avatarUrl) {
      this.signUrl = await this.base64toFile(avatarUrl);
      this.showPopup = false;
    },
    onSubmit() {
      let { signUrl, supplierId } = this;

      if (!signUrl) {
        Toast("请签名")
        return
      }

      try {
        const params = {
          list: [signUrl],
          supplierId,
        };
        teamApi
          .uploadAgreeBookSign(params, { token: this.token })
          .then((res) => {
            if (res.code == 0) {
              Toast("提交成功");
              setTimeout(() => {
                backOff();
              }, 1000);
            }
          });
      } catch (error) {
        console.log("error", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inspection-department {
  background: #fff;
  padding: 20px;
}
.department div {
  margin: 10px 0;
  line-height: 30px;
  color: var(--cell-value-color, #6e6f6f);
  font-family: "Courier New", Courier, monospace;
  text-indent: 2em; /* 实现首行缩进 */
}
.inspection_title {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #000 !important;
  text-indent: 0 !important; /* 标题不需要首行缩进 */
}
.inspection_company {
  text-indent: 0 !important;
}
.unit {
  margin: 40px 0 !important;
  padding-left: 50px;
  position: relative;
  color: var(--cell-value-color, #6e6f6f);
  font-family: "Courier New", Courier, monospace;
}
.dataTime {
  text-align: end;
  color: var(--cell-value-color, #6e6f6f);
  font-family: "Courier New", Courier, monospace;
}
.avatarImage {
  width: 100px;
  position: absolute;
  right: 100px;
  bottom: 10px;
}
.next_step {
  margin: 20px auto;
  text-align: center;
  display: flex;
  justify-content: center;
}

.next_step button {
  width: 330px;
  height: 49px;
  background: linear-gradient(95deg, #ff6e53 0%, #ff0000 100%);
  border: none;
  box-shadow: 0px 6px 12px 0px rgba(229, 53, 47, 0.4);
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  color: #fff;
}
</style>
